import { redirect } from "@tanstack/react-router";

/**
 * Owner-app / email / bookmark URLs that are not real file routes. Invoked from the global
 * NotFoundRoute so we can keep a single redirect table instead of one route file per path.
 */
export function redirectIfMemberLegacyPath(location: {
  pathname: string;
  searchStr: string;
}): void {
  const { pathname, searchStr } = location;

  const exact: Record<string, string> = {
    "/checkout": "/my/checkout",
    "/onboarding": "/my/onboarding",
    "/download-app": "/my/download-app",
    "/verify-phone": "/my/verify-phone",
    "/my/account/manage": "/my/settings/account/profile",
  };

  const to = exact[pathname];
  if (to) {
    throw redirect({ to, replace: true });
  }

  const feedbackMatch = pathname.match(/^\/feedback\/([^/]+)$/);
  if (feedbackMatch) {
    throw redirect({
      href: `/my/feedback/${feedbackMatch[1]}${searchStr}`,
      replace: true,
    });
  }
}
